import {postAuth} from './auth';

export {saga, reducer, getToken, deleteToken} from './auth';

export const apiAuth = {
  postAuth,
};
